<template>
  <v-row
    no-gutters>
    <v-col
      cols="2"
      class="px-2">
      <img
        :src="imageUrl ? $convertImgix(`${imageUrl}?w=1024`) : noPicture"
        style="width: 60px; height: 80px;"
        class="rounded my-1 elevation-1" />
    </v-col>
    <v-col
      cols="7"
      class="px-2">
      <h4 class="product-name subtitle-1 font-weight-bold">
        {{ sketchId }}
      </h4>
      <span class="font-weight-bold">สี</span> : {{ colors }}
    </v-col>
    <v-col
      cols="3"
      class="px-2">
      <v-row
        no-gutters
        class="d-flex flex-column"
        style="height: 100%;">
        <v-col class="d-flex justify-end">
          <v-btn
            class="hide-on-print"
            color="error"
            icon
            @click="removeItem()">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </v-col>

        <v-spacer v-if="!hideInput"></v-spacer>

        <v-col
          v-if="!hideInput"
          class="d-flex justify-end">
          <v-text-field
            v-model.number="innerAmount"
            class="number-field"
            color="secondary"
            outlined
            dense
            min="1"
            hide-details
            prepend-inner-icon="mdi-minus"
            append-icon="mdi-plus"
            @click:prepend-inner="removeAmount()"
            @click:append="addAmount()" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  props: {
    sketchId: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    qty: {
      type: Number,
      default: 1
    },
    hideInput: {
      type: Boolean,
      default: false
    },
    colors: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      noPicture: NoPicture
    }
  },
  computed: {
    innerAmount: {
      get () {
        return this.qty
      },
      set (val) {
        this.$emit('update:qty', val || 1)
      }
    }
  },
  methods: {
    addAmount () {
      this.innerAmount += 1
    },
    removeAmount () {
      if (this.innerAmount === 1) {
        return
      }

      this.innerAmount -= 1
    },
    removeItem () {
      this.$emit('remove-item')
    }
  }
}
</script>

<style scoped>

</style>
